// 版本自檢：部署新版後，開緊嘅舊 tab / WebView 緩存嘅舊 bundle
// 會喺下次開頁、返返嚟個 tab、或轉頁時自動 reload 攞新版。
// 解決「修咗 bug / 出咗新功能，但用戶仲用緊舊版」嘅問題。
//
// 機制：build 時將版本號注入 bundle（__APP_VERSION__）同埋寫入 /version.json。
// 前端定期 fetch /version.json 對比，唔同 → location.reload()。
// reload 後 HTML 係 no-cache/no-store，會攞到新 HTML + 新 hash assets。

declare const __APP_VERSION__: string;

const CHECK_THROTTLE_MS = 60_000; // 非強制檢查最少隔 60 秒（轉頁觸發用）

let checking = false;
let lastCheckAt = 0;

export async function checkAppVersion(force = false): Promise<void> {
  const now = Date.now();
  if (checking) return;
  if (!force && now - lastCheckAt < CHECK_THROTTLE_MS) return;
  checking = true;
  lastCheckAt = now;
  try {
    const res = await fetch(`/version.json?t=${now}`, { cache: 'no-store' });
    if (!res.ok) return;
    // dev server / SPA fallback 會回 HTML，唔當係有效 version file
    if (!(res.headers.get('content-type') || '').includes('application/json')) return;
    const data = (await res.json()) as { version?: string };
    if (!data.version || data.version === __APP_VERSION__) return;
    // 防 loop：同一目標版本只 reload 一次
    // （極端情況 reload 後 CDN 仲係舊 pair，唔會無限循環，下次開頁再試）
    const guardKey = `__gs_version_reload_${data.version}`;
    if (sessionStorage.getItem(guardKey)) return;
    sessionStorage.setItem(guardKey, '1');
    location.reload();
  } catch {
    // 網絡異常靜默，唔影響主程式
  } finally {
    checking = false;
  }
}

export function initVersionCheck(): void {
  // 1) 開頁即檢查（每次撳 link 入嚟都保證最新）
  void checkAppVersion(true);
  // 2) 由其他 app / tab 返返嚟時檢查（admin 長開 tab 嘅主要更新途徑）
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void checkAppVersion(true);
  });
}
